import { render } from "./XIconSolidRefreshCw.vue?vue&type=template&id=63cbce67"
import script from "./XIconSolidRefreshCw.vue?vue&type=script&lang=js"
export * from "./XIconSolidRefreshCw.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidRefreshCw.vue"]])

export default __exports__